

<template>
  <GravManagerWrapper :id="id" :componentName="componentName" :properties="props">
    <component :is="AvatarBox" v-bind="{ style: $attrs.style, ...changableProps }">
      <template v-for="slotName in Object.keys($slots)" #[slotName]="slotProps">
        <slot :name="slotName" v-bind="slotProps" />
      </template>
    </component>
  </GravManagerWrapper>
</template>

<script setup lang="ts">
import { AvatarBoxProps } from './AvatarBox.ts';
import AvatarBox from './AvatarBox.vue';
import GravManagerWrapper from './GravManagerWrapper.vue';

import { useChangableProps } from '@/composables/useChangableProps';

const componentName = 'ui-avatar-box';
const $slots = defineSlots<Record<string, unknown>>();

const props = defineProps<AvatarBoxProps>();
const changableProps = useChangableProps(componentName, props);

</script>
